import { apiClient } from './api';
import type { LoginRequest, LoginResponse, User } from '../types/auth';

export const authService = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse['data']>('/auth/login', credentials);
    
    if (response.success && response.data) {
      // Store token and user data
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    
    return {
      success: response.success,
      message: response.message,
      data: response.data!
    };
  },

  logout: (): void => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getProfile: async (): Promise<User> => {
    const response = await apiClient.get<{ user: User }>('/auth/profile');
    return response.data!.user;
  },

  changePassword: async (currentPassword: string, newPassword: string): Promise<void> => {
    await apiClient.post('/auth/change-password', {
      currentPassword,
      newPassword
    });
  },

  refreshToken: async (): Promise<string> => {
    const response = await apiClient.post<{ token: string }>('/auth/refresh-token');
    
    if (response.success && response.data) {
      localStorage.setItem('token', response.data.token);
      return response.data.token;
    }
    
    throw new Error('Failed to refresh token');
  },

  getCurrentUser: (): User | null => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  getToken: (): string | null => {
    return localStorage.getItem('token');
  },

  isAuthenticated: (): boolean => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    return !!(token && user);
  }
};
